export class CreateNotebookInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "createdBy",
            "baseName": "createdBy",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateNotebookInput.attributeTypeMap;
    }
    constructor() {
    }
}
